import Start from "./Start.vue";
import Confirm from "./Confirm.vue";
import End from "./End.vue";

export default {
  routes: [
    {
      path: "/register",
      component: Start,
    },
    {
      path: "/register/confirm",
      component: Confirm,
    },
    {
      path: "/register/end",
      component: End,
    },
  ],
};
